/**
 * PATH: apps/qa/src/pages/records/useJobRows.ts
 * FILE_ID: QA-RECORDS-JOB-ROWS-001
 * PURPOSE: One QA-home row per job from GET /api/qa/job-rows/.
 */
import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'

type QaHttp = {
  get: (url: string, config?: { params?: Record<string, unknown> }) => Promise<{ data: unknown }>
  post: (url: string, body?: unknown) => Promise<{ data: unknown }>
}

function qaHttp(): QaHttp {
  const client = api as unknown as QaHttp & (() => QaHttp)
  if (typeof client.get === 'function') return client
  return client()
}

export interface QaJobRowLatest {
  id: string
  inspection_name?: string
  status?: string
  created_at?: string
  job_id?: string | number
  client_name?: string | null
  site_name?: string | null
  category?: string | null
  job_name?: string | null
}

export interface QaJobRow {
  job_id: string | number
  company_slug?: string | null
  client_name?: string | null
  site_address?: string | null
  qa_count: number
  latest: QaJobRowLatest | null
}

export interface QaJobRowsPage {
  count: number
  results: QaJobRow[]
}

export function useJobRows({
  enabled,
  params,
}: {
  enabled: boolean
  params: Record<string, string | number>
}) {
  return useQuery({
    queryKey: ['qa-job-rows', params],
    queryFn: async () => {
      const response = await qaHttp().get('/qa/job-rows/', {
        params: { days: 548, ...params },
      })
      const payload = response.data as QaJobRowsPage
      return {
        count: Number(payload?.count ?? 0),
        results: Array.isArray(payload?.results) ? payload.results : [],
      }
    },
    enabled,
  })
}
